/**
 * truncates the string
 * @param str
 * @param num
 * @returns {*}
 */
export function truncate(str, num, add_dots) {
	num = num - 1;
	str = str.trim();
	let st = '';
	if (!(typeof add_dots !== 'undefined' && add_dots !== null)) {
		add_dots = true;
	}
	// if the limit is greater than the string length
	if (num >= str.length) {
		return str;
	}
	else if (num < str.length && num > 3) {
		st = str.slice(0, num);
	}

	else if (num <= 3) {
		st = str.slice(0, num);
	}

	if(add_dots){
		return st.trim() + '...';
	}
	return st.trim();
}

export function curlys(str) {
	return str.match(/[^{\}]+(?=})/g)
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/format.string.js